import React from 'react';
import { Button } from './ui/Button';
import { FileText, Clock, Calendar, CheckCircle2, Package, Star, Users, BookOpen, Gift, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden pt-8 pb-12 px-4 md:pt-16 md:pb-20" data-id="element-208">
      {/* subtle radial glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-primary/10 blur-[120px] rounded-full pointer-events-none" data-id="element-209" />

      <div className="relative max-w-5xl mx-auto text-center" data-id="element-210">
        {/* Eyebrow */}
        <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/30 rounded-full px-4 py-1.5 text-[11px] md:text-sm font-bold text-primary mb-5 md:mb-7 font-space-grotesk tracking-wider uppercase" data-id="element-211">
          🍑 30 DÍAS DE GLÚTEOS
        </div>

        {/* Headline (above mockup) */}
        <h1 className="text-[1.65rem] md:text-6xl font-extrabold leading-[1.1] mb-4 md:mb-6 tracking-tight" data-id="element-212">
          Glúteos grandes en 30 días.{' '}
          <span className="text-primary" data-id="element-213">Tu transformación empieza hoy.</span>
        </h1>

        {/* Mockup (centered, clickable → pricing) */}
        <a href="#pricing" className="my-5 md:my-8 flex justify-center group" aria-label="Ver oferta de 30 Días de Glúteos" data-id="element-214">
          <img src="https://cdn.magicpatterns.com/uploads/kZJkFwjjjWN5FJ9K2P4bX5/ChatGPT_Image_28_may_2026,_07_35_39_p.m..png" alt="30 Días de Glúteos — 4 Tomos + Bono Recetario" className="w-[85%] max-w-[560px] md:w-full md:max-w-[640px] object-contain drop-shadow-[0_0_60px_rgba(249,168,212,0.35)] transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-215" />
        </a>

        {/* Subheadline (below mockup) */}
        <p className="text-base md:text-2xl text-zinc-300 mb-2 md:mb-4 max-w-3xl mx-auto leading-snug font-medium" data-id="element-216">
          4 Tomos + Bono Recetario — Tu transformación completa. El plan, la
          técnica, la cintura y la alimentación. Todo en un solo lugar.
        </p>

        {/* Support copy */}
        <p className="text-xs md:text-base text-zinc-400 mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed mt-4" data-id="element-217">
          Creado para mujeres argentinas que quieren glúteo real, cintura
          marcada y resultados visibles en 30 días.
        </p>

        {/* Quick bullets */}
        <div className="flex flex-wrap justify-center gap-x-3 gap-y-2 md:gap-x-5 mb-7 md:mb-8 text-xs md:text-sm text-zinc-300" data-id="element-218">
          <div className="flex items-center gap-1.5" data-id="element-219">
            <FileText className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary" data-id="element-220" /> 100%
            PDF
          </div>
          <div className="flex items-center gap-1.5" data-id="element-221">
            <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary" data-id="element-222" /> Acceso
            en 5 min
          </div>
          <div className="flex items-center gap-1.5" data-id="element-223">
            <Calendar className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary" data-id="element-224" /> 30
            días de plan
          </div>
          <div className="flex items-center gap-1.5" data-id="element-225">
            <Package className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary" data-id="element-226" /> 4
            Tomos + 1 Bono
          </div>
          <div className="flex items-center gap-1.5" data-id="element-227">
            <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary" data-id="element-228" />{' '}
            🇦🇷 Para mujeres argentinas
          </div>
        </div>

        {/* CTA */}
        <Button href="#pricing" className="text-base md:text-2xl py-4 md:py-5 px-8 md:px-10 w-full md:w-auto mb-4 md:mb-5" data-id="element-229">
          👉 QUIERO MIS 30 DÍAS DE GLÚTEOS AHORA
        </Button>

        {/* Trust microcopy */}
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] md:text-sm text-zinc-400 font-medium mb-10 md:mb-14" data-id="element-230">
          <span className="flex items-center gap-1" data-id="element-231">
            <Shield className="w-3 h-3 md:w-3.5 md:h-3.5 text-primary" data-id="element-232" />{' '}
            Garantía 7 días
          </span>
          <span className="text-zinc-700" data-id="element-233">·</span>
          <span className="flex items-center gap-1" data-id="element-234">
            <Lock className="w-3 h-3 md:w-3.5 md:h-3.5 text-primary" data-id="element-235" /> Pago
            seguro
          </span>
          <span className="text-zinc-700" data-id="element-236">·</span>
          <span className="flex items-center gap-1" data-id="element-237">
            <CreditCard className="w-3 h-3 md:w-3.5 md:h-3.5 text-primary" data-id="element-238" />{' '}
            Mercado Pago
          </span>
        </div>

        {/* Social proof badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto" data-id="element-239">
          {[{
          icon: Users,
          label: '+200 mujeres ya transformadas'
        }, {
          icon: BookOpen,
          label: '4 tomos listos para usar'
        }, {
          icon: Gift,
          label: 'Bono Recetario incluido'
        }, {
          icon: Star,
          label: '4.9/5 ⭐⭐⭐⭐⭐'
        }].map(({
          icon: Icon,
          label
        }, i) => <div key={i} className="bg-surface/60 backdrop-blur-sm border border-zinc-800 rounded-2xl p-3 md:p-4 flex flex-col items-center gap-1.5 hover:border-primary/40 transition-colors" data-id="element-240">
              <Icon className="w-4 h-4 md:w-5 md:h-5 text-primary" data-id="element-241" />
              <span className="text-[11px] md:text-sm font-bold text-white text-center leading-tight" data-id="element-242">
                {label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}